// extracted by mini-css-extract-plugin
export default {"searchFiltersMobile":"FiltersComponentMobile_searchFiltersMobile__2Z4w8"};